// extracted by mini-css-extract-plugin
export default {"cls1":"uwCBrcFHQcQRv71v6_0A","cls2":"VU30iCpl45gP0Py0I6Ij uwCBrcFHQcQRv71v6_0A"};